import { resolveToolCallLabels } from '@terra/shared-dto-chat-types';
import { getToolConfig } from './tool-config';

const GENERIC_LABELS = new Set(['action', 'working', 'tried this step']);

export function clientFacingToolName(toolName: string): string {
  const configuredName = getToolConfig(toolName).name.trim();

  if (
    configuredName.length > 0 &&
    !GENERIC_LABELS.has(configuredName.toLowerCase())
  ) {
    return configuredName;
  }

  const pastLabel = resolveToolCallLabels({ toolName }).labelPast.trim();

  if (
    pastLabel.length > 0 &&
    !GENERIC_LABELS.has(pastLabel.toLowerCase()) &&
    !pastLabel.includes('__')
  ) {
    return pastLabel;
  }

  return humanizeToolId(toolName);
}

function humanizeToolId(toolName: string): string {
  const tail = toolName.split('__').filter(Boolean).at(-1) ?? toolName;
  const words = tail
    .replace(/^terra_/, '')
    .replace(/[-_]+/g, ' ')
    .trim();

  return words.replace(/\b\w/g, (character) => character.toUpperCase());
}
